import Konva from 'konva'
const controlWidget = {}

const PADDING = 10

controlWidget.create = (position, addNodeEvent = node => {}) => {
  const text = new Konva.Text({
    text: '#LABEL',
    fill: '#fff',
    fontSize: 20,
    padding: PADDING
  })
  const label = new Konva.Label({
    name: 'controlWidget',
    bind: {
      deviceId: '',
      driverType: '',
      protocolCode: '',
      startAddress: null,
      pointName: '',
      pointCode: '',
      range: [null, null],
      defaultValue: '',
      coefficient: '',
      dtuCode: '',
      unit: ''
    },
    x: position.x,
    y: position.y
  })
  const bg = new Konva.Tag({
    fill: '#208af3',
    width: 100,
    height: 50,
    cornerRadius: 5
  })
  label.add(bg, text)
  addNodeEvent(label)
  label.on('mouseover', evt => {
    evt.currentTarget.getStage().container().style.cursor = 'pointer'
  })
  label.on('mouseleave', evt => {
    evt.currentTarget.getStage().container().style.cursor = 'default'
  })
  return label
}

controlWidget.load = (label, addNodeEvent = node => {}) => {
  addNodeEvent(label)
  label.on('mouseover', evt => {
    evt.currentTarget.getStage().container().style.cursor = 'pointer'
  })
  label.on('mouseleave', evt => {
    evt.currentTarget.getStage().container().style.cursor = 'default'
  })
}

export default controlWidget
